import { useSyncExternalStore } from 'react';
import {
  getBootStage,
  subscribeBootStage,
  getBootStageVersion,
} from '../lib/bootStage.js';

/** Subscribe to the current boot stage (re-renders on change). */
export default function useBootStage() {
  return useSyncExternalStore(subscribeBootStage, getBootStage, getBootStage);
}

export function useBootStageVersion() {
  return useSyncExternalStore(subscribeBootStage, getBootStageVersion, getBootStageVersion);
}
